import { Injectable, ErrorHandler } from '@angular/core';

declare global {
  interface Window {
    newrelic?: {
      noticeError(error: Error | string, customAttributes?: Record<string, any>): void;
      addPageAction(name: string, attributes?: Record<string, any>): void;
    };
  }
}

@Injectable()
export class GlobalErrorHandlerService implements ErrorHandler {
  handleError(error: Error): void {
    console.error('Global error caught:', error);
    
    if (window.newrelic && typeof window.newrelic.noticeError === 'function') {
      const errorAttributes = {
        timestamp: new Date().toISOString(),
        userAgent: navigator.userAgent,
        url: window.location.href,
        stack: error.stack,
        message: error.message,
        name: error.name,
        source: 'angular-error-handler'
      };

      window.newrelic.noticeError(error, errorAttributes);
    }
  }
}